import { Box, Typography, Button } from "@mui/material"

export const CustomTourTooltip = ({step, primaryProps, skipProps, backProps, tooltipProps, size, index, setter, controls })=>{
    
    return(
        <Box {...tooltipProps} sx={{ p: 3, borderRadius: 2, position: "relative", minWidth: 200, maxWidth: 300, bgcolor: "#fff"}}>
            <Box>
                {/* <Box sx={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                    <Typography sx={{ fontSize: 18, fontWeight: 800, color: "primary.main"}}>{step.title}</Typography>
                    <Typography sx={{ fontSize: 18, fontWeight: 500 }}>{index + 1} of {size}</Typography>
                </Box> */}
            
                <Typography sx={{ fontSize: 16, fontWeight: 500, my: 2,}}>{step.content}</Typography>
                {controls &&
                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                        <Button {...skipProps} sx={{textTransform: "none", fontSize: 14}} /*onClick={setter}*/>Skip</Button>
                        <Button {...primaryProps} variant="contained" sx={{ bgcolor: "#0A7C3E", color: "#fff", borderRadius: 5, px: 3, textTransform: "none", fontSize: 14}}>{(index) === size - 1 ? "Got it" : "Next"}</Button>
                    </Box>
                }

            </Box>
        </Box>
    )
}
